// @ts-nocheck
import { LangDropdown, PUBLIC_UI, setPreferredLanguage } from './public-data'

export const PublicTopbar = ({ onLogin, onSignup, lang, setLang, navigate }) => {
  const ui = PUBLIC_UI[lang] || PUBLIC_UI.EN
  return (
    <header className="bbg-topbar">
      <button className="bbg-logo" onClick={() => navigate('/')} style={{ background: 'transparent', border: 0, padding: 0, cursor: 'pointer' }} aria-label="BookBuilderGo home">
        BookBuilder<span>Go</span>
      </button>
      <div className="bbg-topbar-actions">
        <LangDropdown lang={lang} setLang={(code) => setPreferredLanguage(code, setLang)} iconOnly />
        <button type="button" className="bbg-btn bbg-btn-ghost bbg-topbar-btn bbg-topbar-login" onClick={onLogin}>{ui.login}</button>
        <button type="button" className="bbg-btn bbg-btn-primary bbg-topbar-btn bbg-topbar-get-started" onClick={onSignup}>{ui.getStarted}</button>
      </div>
    </header>
  )
}
